<template>
  <div id="doubtView">
  	<div class="solution-wrapper">
      <span v-if="current_doubt.doubt_status=='completed'" class="green-bg solved">Solved &#10003;</span>
      <span v-else class="yellow-bg unsolved">Pending!</span>
  		<h5 style="margin-top:10px">{{current_doubt.title}}</h5>
      <p>{{current_doubt.description}}</p>
      <div v-if="current_doubt.attachment_filename != '' && current_doubt.attachment_filename != null">
        <p>Attachment:</p>
        <loader v-if="img_source == ''"></loader>
        <img :src="img_source" style="width:100%; display:block;"/>
      </div>
      <div>

      <div v-if="current_doubt.doubt_status=='completed'">
        <h4 style="margin-top:20px">Solution:</h4>
        <p>{{solution.description}}</p>
      </div>

      <div v-if="current_doubt.doubt_status=='pending'">
        <h4 style="margin-top:20px">Solution:</h4>
        <!-- <textarea v-model="form.solution_description">
          {{form.solution_description}}
        </textarea> -->
        <b-form-textarea id="textarea1"
                             v-model="form.solution_description"
                             placeholder="Enter something"
                             :rows="3"
                             :max-rows="6">
        </b-form-textarea>
        <b-form-file v-model="solution_attachment_file_obj" :state="Boolean(solution_attachment_file_obj)" placeholder="Choose a file..." style="margin-top:20px"></b-form-file>
        <b-button class="btn query-btn button-touchy" variant="primary" style="margin-top: 20px; margin-left:0" @click="execute_add_solution">Submit Answer</b-button>
      </div>

      <loader v-if="solution.attachment_filename != '' && solution_img_source == '' && solution.attachment_filename != null"></loader>
      <div v-if="solution_img_source != ''">

        <img :src="solution_img_source" style="width:100%; display:block;"/>
      </div>
        
      </div>
  		
  	</div>
  </div>
</template>

<script>
import dropdown from 'vue-my-dropdown';
import moment from 'moment';
import _ from 'lodash';
import loader from '../Loader.vue';

export default {
  name: 'DoubtView',
  components: {
    loader
  },
  data () {
    return {
      msg: 'Welcome to QdsProz',
      the_doubt: {
      	title:'',
      	description:'',
      	created_at:'',
      	doubt_status:'',
      	solution: null,
      	attachment_filename:''
      },
      img_source:'',
      solution:{
        description:'',
        attachment_filename:''
      },
      solution_img_source:'',
      solution_attachment_file_obj:null,
      form: {
        solution_description:''
      }
    }
  },
  mounted: async function() {
    if(this.current_doubt.attachment_filename != null) {
      this.get_attachment();
    }

    if(this.current_doubt.doubt_status == 'completed') {
      this.get_solution();
      this.get_solution_attachment();
    }
  },
  computed: {
    user: function() {
      return this.$store.getters.user
    },
    doubts: function(){
      return this.$store.getters.doubts;
    },
    current_doubt: function() {
    	var doubt_id = this.$route.params.id;
      //return this.$route.params.id;
    	return _.find(this.doubts, {'id':Number(doubt_id)});
    }
  },
  methods: {
    get_human_date(d) {
      let mom = moment(d);
      return mom.format('LL');
    },
    async get_attachment() {
      var action = await this.$store.dispatch('fetch_doubt_attachment',this.current_doubt.id);

      //var attachment = action.data;

      var attachment = action.data.data;

      var source  = 'data:'+ attachment.attachment_type + ';base64,'+ attachment.attachment_data;

      this.img_source = source;
      
    },
    async get_solution() {
      var action = await this.$store.dispatch('fetch_doubt_solution', this.current_doubt.id);

      this.solution = action.data.data[0];
    },
    async execute_add_solution() {
      if(this.form.solution_description == '') {
        this.$toasted.show('Please type the solution',{type:'error'});
        return;
      }

      var api_form = {
        doubt_id: this.current_doubt.id,
        description: this.form.solution_description
      }

      this.$store.commit('setLoader',true);
      
      if(this.solution_attachment_file_obj != null) {

        var FR = new FileReader();
      
        FR.onload = async (ev) => {
          console.log('file read success');
          api_form.attachment = btoa(ev.target.result);
          api_form.attachment_type = this.solution_attachment_file_obj.type;
          try {
            var result = await this.$store.dispatch('add_solution',api_form);
            this.$toasted.show('Solution Added!',{type:'success'});
            this.get_solution();
            this.get_solution_attachment();
            this.$store.commit('setLoader',false);
            //this.$router.push('/dashboard/solutions');
          } catch (ex) {
            this.$store.commit('setLoader',false);
            this.$toasted.show(ex.toString(),{type:'error'});
          }

        };

        FR.readAsBinaryString(this.solution_attachment_file_obj);
      
      } else {
        try {

            var result = await this.$store.dispatch('add_solution',api_form);
            this.$toasted.show('Solution Added!',{type:'success'});
            this.get_solution();
            this.get_solution_attachment();
            this.$store.commit('setLoader',false);
            
          } catch (ex) {
            this.$toasted.show(ex.toString(),{type:'error'});
        }
      }
    },
    async get_solution_attachment() {

      try {
        var action = await this.$store.dispatch('fetch_doubt_solution_attachment',this.current_doubt.id);

        

        var attachment = action.data.data;

        var source  = 'data:'+ attachment.attachment_type + ';base64,'+ attachment.attachment_data;

        this.solution_img_source = source;

      } catch(ex) {
        console.log(ex.toString());
      }
      
    },
  },
  watch: {
    $route(to,from) {
      this.get_attachment();
      this.get_solution();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date {
  font-size: 0.8rem;
}
.solution-header {
	margin: 30px 0;
}
#solutions .custom-select,.sol-filter .form-control,.query-btn {
	border-radius: 20px;
	font-size: .8rem;
	line-height: 1.6rem;
}
.query-btn {
	width: 100%;
}
.sol-rating {
	display: inline-flex;
	justify-content: space-evenly;
	align-items: center;
}
.solution-link {
	background-color: #fff;
	margin: 10px 0px;
	display: block;
	color: #ffce00;
	padding: 20px;
}
.solution-link p {
	margin: 0;
}
.star-rating {
  line-height:32px;
  font-size:1.25em;
}
.sol-view {
	font-size: 3rem;
	line-height: 3rem;
	text-align: right;
}
.text-center {
	text-align: center;
}
.solution-link {
	border-left: 5px solid;
	border-color: #959090;
}
.qds-active-border {
	border-color:  #AACF37;
}

.doubt-description {
    display: none;
}

.green-bg.solved {
  background-color: #77bf43;
  padding: 5px;
  display: inline-block;
  box-shadow: 0px 1px 15px 1px rgba(69,65,78,0.3);
  border-radius: 5px;

}
.yellow-bg.unsolved {
  background-color: #ffce00;
  padding: 5px;
  display: inline-block;
  box-shadow: 0px 1px 15px 1px rgba(69,65,78,0.1);
  border-radius: 5px;

}

@media screen and (min-width: 1280px) {
  .doubt-description {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DoubtView.vue